import { useEffect } from 'react';
import { connectBacktestWs } from '../ws/backtestWsClient';

export default function BacktestLoader() {
  useEffect(() => {
    const disconnect = connectBacktestWs();
    return () => disconnect?.();
  }, []);

  return null;
}
